module.exports = __webpack_public_path__ + "776e2bf3f6938bf2070e18d10f3a57fd.svg";